import useRouteParamNameWIthId from 'hooks/useRouteParamNameWIthId/useRouteParamNameWIthId'
import NewUOM from './NewUOM'
import { isNaN } from 'lodash-es'

function EditUOM() {
    const pathID = useRouteParamNameWIthId()

    const convertedID = Number(pathID)

    if (isNaN(convertedID)) return <></>

    return <NewUOM uomID={convertedID} />
}

export default EditUOM
